import { action, observable } from "mobx";

import apiUrl from "@const/apiUrl";
import baseState from "../../baseState";

export default class casterState extends baseState {
  // 导播台初始化接口 11个
  casterInit = (action, data) => {
    return this.fetch({
      url: apiUrl.CASTER.CASTER_INIT + action,
      data,
    });
  }
}
